<template>
  <div class="trackDetail">
    <div class="flex text_left">
      <div class="trigger">
        <div class="font_bold row_head">
          {{ $t("trackPay.trackProgressModal.trigger") }}
        </div>
        <div>
          <div class="row-item flex" v-for="(item, index) in triggerData" :key="index">
            <div class="row_label gray_light_color">{{ $t(item.label) }}</div>
            <div class="row_value">{{ item.value }}</div>
          </div>
        </div>
      </div>
<!--not deleted since it will be needed in the future-->
<!--      <div class="events">-->
<!--        <div class="font_bold row_head">-->
<!--          {{ $t("trackPay.trackProgressModal.events") }}-->
<!--        </div>-->
<!--        <div>-->
<!--          <div class="row-item flex" v-for="(item, index) in eventsData" :key="index">-->
<!--            <div class="row_label gray_light_color">{{ $t(item.label) }}</div>-->
<!--            <div class="row_value">{{ item.value }}</div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
    </div>
  </div>
</template>
<script>
export default {
  props: {
    rowData: {},
  },
  data() {
    return {
      triggerData: [
        {
          label: "trackPay.contractsEditModal.incoterm",
          value: this.rowData.incoTerms,
        },
        {
          label: "trackPay.contractsEditModal.delivery",
          value: this.rowData.toAddress,
        },
        {
          label: "trackPay.contractsEditModal.estimatedDeliveryDate",
          value: this.rowData.estimatedDeliveryDate,
        },
        {
          label: "trackPay.trackProgressModal.daysTolerance",
          value: "+/- " + this.rowData.deliveryDateTolerance + " " + this.$t("common.days"),
        },
      ],
      eventsData: [
        {
          label: "trackPay.trackersForm.shock",
          value: "max. 2g",
        },
        {
          label: "trackPay.trackersForm.temperature",
          value: "max. 40°C",
        },
        {
          label: "trackPay.trackProgressModal.airPressure",
          value: "min. 900hPa",
        },
        {
          label: "trackPay.trackProgressModal.humidity",
          value: "max. 80%",
        },
      ],
    };
  },
};
</script>
<style lang="scss" scoped>
.trackDetail {
  .row_head {
    margin-bottom: 40px;
  }

  .row-item {
    margin-bottom: 20px;
    text-align: left;
    font-size: 12px;
  }

  .row_label {
    // color: #a0a4a9;
    width: 150px;
    display: inline-block;
  }

  .trigger {
    margin-right: 70px;
  }

  .events {
    .row_label {
      width: 90px;
    }
  }
}
</style>
